<button type="button" class="bcard" [ngClass]="'bcard--' + theme" (click)="onClick()" @fadeInUp>
  <span class="bcard__ic" [ngClass]="'bcard__ic--' + theme">
    <i class="bi" [ngClass]="icon"></i>
  </span>
  <h3 class="bcard__title">{{ title }}</h3>

  @if (counts.length > 0) {
    <div class="flex flex-col gap-1.5">
      @for (count of counts; track count.label) {
        <div class="flex items-center gap-2.5">
          <span class="bcard__badge" [ngClass]="'bcard__badge--' + count.color">{{ count.value }}</span>
          <span class="text-sm font-semibold text-[#3a3a6e]">{{ count.label }}</span>
        </div>
      }
    </div>
  } @else if (subtitle) {
    <p class="m-0 text-sm text-gray-500">{{ subtitle }}</p>
  }
</button>
